import { all, call, put, takeLatest, select } from "redux-saga/effects";
import { PROYECT, api_get } from "../../services/api";
import { orderCompaniesAndStations } from "../../helpers/companiesNormalized";
import { openSnackbar } from "./globalSnackbar";
import { BLUE_RGB } from "../../utils/colorsTheme";

const types = {
  CLEAR_PRICES_BUSINESS: "CLEAR_PRICES_BUSINESS",
  LOAD_DATA_PRICES_BUSINESS: "LOAD_DATA_PRICES_BUSINESS",
  SET_DATA_PRICES_BUSINESS: "SET_DATA_PRICES_BUSINESS",
  ERROR_DATA_PRICES_BUSINESS: "ERROR_DATA_PRICES_BUSINESS",
  LOAD_PRICES_PRICES_BUSINESS: "LOAD_PRICES_PRICES_BUSINESS",
  SET_PRICES_PRICES_BUSINESS: "SET_PRICES_PRICES_BUSINESS",
  ERROR_PRICES_PRICES_BUSINESS: "ERROR_PRICES_PRICES_BUSINESS",
  CHANGE_COMPANY_PRICES_BUSINESS: "CHANGE_COMPANY_PRICES_BUSINESS",
};

const INITIAL_STATE = {
  graphs: [],
  prices: null,
  isLoading: false,
  companies: [],
  isLoadingFilters: false,
  companiesSelected: "",
};

export const pricesBusinessReducer = (
  state = INITIAL_STATE,
  { type, payload }
) => {
  switch (type) {
    case types.LOAD_DATA_PRICES_BUSINESS:
      return {
        ...state,
        companies: [],
        graphs: [],
        prices: null,
        isLoadingFilters: true,
      };
    case types.SET_DATA_PRICES_BUSINESS:
      return {
        ...state,
        companies: payload.companies,
        prices: payload.prices,
        graphs: payload.graphs,
        isLoadingFilters: false,
      };
    case types.ERROR_DATA_PRICES_BUSINESS:
      return {
        ...state,
        isLoadingfilters: false,
      };
    case types.LOAD_PRICES_PRICES_BUSINESS:
      return {
        ...state,
        graphs: [],
        isLoading: true,
      };
    case types.SET_PRICES_PRICES_BUSINESS:
      return {
        ...state,
        graphs: payload.graphs,
        isLoading: false,
      };
    case types.ERROR_PRICES_PRICES_BUSINESS:
      return {
        ...state,
        isLoading: false,
      };
    case types.CHANGE_COMPANY_PRICES_BUSINESS:
      return {
        ...state,
        companiesSelected: payload.companies,
      };
    case types.CLEAR_PRICES_BUSINESS:
      return {
        ...state,
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

// Actions
export function getData() {
  return {
    type: types.LOAD_DATA_PRICES_BUSINESS,
  };
}

export function getPrices(companies) {
  return {
    type: types.LOAD_PRICES_PRICES_BUSINESS,
    payload: {
      companies,
    },
  };
}

export function changeCompanies(companies) {
  return {
    type: types.CHANGE_COMPANY_PRICES_BUSINESS,
    payload: { companies },
  };
}

// Sagas
function* fetchData() {
  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const companiesUrl = `${process.env.REACT_APP_URL}${PROYECT}/companies`;
  const profitsUrl = `${process.env.REACT_APP_URL}${PROYECT}/prices/graphs/totals`;

  try {
    const [companies, profits] = yield all([
      call(api_get, companiesUrl, auth),
      call(api_get, profitsUrl, auth),
    ]);
    const { global, companies: companiesGraphs } = profits;
    const orderedCompanies = orderCompaniesAndStations(companies.companies);
    const companiesNormalized = orderedCompanies.map((company) => {
      return {
        ...company,
        value: company.id,
        label: company.name,
      };
    });
    const newGraphsPrices = global.datasets.map((dataset) => {
      return {
        ...dataset,
        fill: false,
        backgroundColor: BLUE_RGB,
        borderColor: BLUE_RGB,
      };
    });
    const newGraphs = companiesGraphs.map((graph) => {
      return {
        ...graph,
        datasets: graph.datasets
          ? graph.datasets.map((dataset) => ({
              ...dataset,
              fill: false,
              backgroundColor: BLUE_RGB,
              borderColor: BLUE_RGB,
            }))
          : [],
      };
    });

    yield put({
      type: types.SET_DATA_PRICES_BUSINESS,
      payload: {
        companies: companiesNormalized,
        prices: { ...global, datasets: newGraphsPrices },
        graphs: newGraphs,
      },
    });
  } catch (message) {
    yield put({
      type: types.ERROR_DATA_PRICES_BUSINESS,
    });
    yield put(openSnackbar(message, "danger"));
  }
}

export function* pricesBusinessSaga() {
  yield takeLatest(types.LOAD_DATA_PRICES_BUSINESS, fetchData);
}
